import { createApi } from 'store/slices/createApi';
import { createBaseQuery } from '../../slices';
import { TAG_TYPES } from 'types/services';

export const coreApi = createApi({
  reducerPath: 'coreApi',
  baseQuery: createBaseQuery({
    extendedUrl: 'core',
  }),
  tagTypes: [
    TAG_TYPES.USERS,
    TAG_TYPES.USER_DETAIL,
    TAG_TYPES.LOGIN,
    TAG_TYPES.SETTINGS,
    TAG_TYPES.ROLES,
    TAG_TYPES.MODULES,
    TAG_TYPES.ROLE_DETAIL,
    TAG_TYPES.FAVORITE_USER_MODULES,
    TAG_TYPES.NOTIFICATIONS,
    TAG_TYPES.AGENDAS_FAVORITE,
    TAG_TYPES.SUBSTITUTABILITY,
    TAG_TYPES.USER_SUBSTITUTIONS,
    TAG_TYPES.USER_SUBSTITUTION_DETAIL,
    TAG_TYPES.USER_SUBSTITUTIONS_AS_SUBSTITUTE,
    TAG_TYPES.DASHBOARD,
    TAG_TYPES.USER_NOTIFICATIONS,
    TAG_TYPES.ASSISTANTS,
    TAG_TYPES.SHARE_GRANTS,
  ],
  endpoints: () => ({}),
});
